// Listen for clicks on the body. This event will always be picked up, even if page content changes
document.addEventListener('click', (event) => {

    // If the clicked element wasn't a tab, bail early
    if(!event.target.closest('.tab')) return

    const targetTab = event.target.closest('.tab')
    const tabTitle = document.querySelectorAll(".tab")
    const tabContent = document.querySelectorAll(".tab__content")
    let tabName

    // Remove all active states from tabs
    tabTitle.forEach((item) => {
      item.classList.remove("--is-active")
    })

    // Add active state to clicked tab
    targetTab.classList.add("--is-active")

    tabName = targetTab.getAttribute("data-tab")

    // Set each tab as either inactive or active if it is the target tab
    tabContent.forEach((item) => {
      item.classList.contains(tabName) ?
      item.classList.add("--is-active") :
      item.classList.remove("--is-active")
    })
  })

  // Tab Closing
  document.addEventListener('click', (event) => {
    if(!event.target.closest('[data-close-tab]')) return

    const tabTitle = document.querySelectorAll(".tab")
    const tabContent = document.querySelectorAll(".tab__content")

    tabTitle.forEach((item) => {
      item.classList.remove("--is-active")
    })

    tabContent.forEach((item) => {
      item.classList.contains("results-list") ?
      item.classList.add("--is-active") :
      item.classList.remove("--is-active")
    })
  })
